import axios from "axios";

export const getStripeAccountId = async () => {
  const url = `${process.env.REACT_APP_SERVER_URL}/api/v1/company/payments/company-stripe-id`;
  console.log("getStripeAccountId: Fetching from URL:", url);
  try {
    const res = await axios.get(url);
    console.log("getStripeAccountId: Response received:", res.data);
    return res.data;
  } catch (error: any) {
    console.error("getStripeAccountId: Error fetching Stripe account ID:", error);
    console.error("getStripeAccountId: Error response:", error.response?.data);
    console.error("getStripeAccountId: Error status:", error.response?.status);
    throw error;
  }
};
